export default class Str {
    trim(string) {
        string = string.trim();

        if (string.startsWith('/')) {
            string = string.substring(1);
        }

        if (string.endsWith('/')) {
            string = string.slice(0, -1);
        }

        return string;
    }

    static after(string, needed) {
        const split =  string.split(needed);

        if (split[1] ?? null) {
            return split[1];
        }

        return null;
    }

    static before(string, needed) {
        const split =  string.split(needed);

        if (split[0] ?? null) {
            return split[0];
        }

        return null;
    }

    static between(string, first, second) {
        let match = this.after(string, first);

        if (match === null || match === '') {
            return null;
        }

        match = this.before(match, second);

        return match;
    }
}
